export const DEGREE_LIST = [
  {
    label: "All",
    value: "All",
    pixelName: "All",
    id: "all",
    order: 1,
    path: "all",
    isActive: true,
  },
  {
    label: "Associate's",
    value: "ASSOCIATE",
    pixelName: "Associate",
    id: "associate",
    order: 3,
    path: "associate",
    isActive: true,
  },
  {
    label: "Bachelor's",
    value: "BACHELOR",
    pixelName: "Bachelor",
    id: "bachelor",
    order: 4,
    path: "bachelors",
    isActive: true,
  },
  {
    label: "Certificate",
    value: "CERTIFICATE_DIPLOMA",
    pixelName: "Certificate-Diploma",
    id: "certificate_diploma",
    order: 2,
    path: "certificate-diploma",
    isActive: true,
  },
  {
    label: "Doctorate",
    value: "DOCTORATE_SPECIALIST",
    pixelName: "Doctorate-Specialist",
    id: "doctorate_specialist",
    order: 6,
    path: "doctorate",
    isActive: true,
  },
  {
    label: "Graduate Certificate",
    value: "GRADUATE_CERTIFICATE",
    pixelName: "Graduate-Certificate",
    id: "graduate_certificate",
    order: 7,
    path: "graduate-certificate",
    isActive: false,
  },
  {
    label: "Master's",
    value: "MASTER",
    pixelName: "Master",
    id: "master",
    order: 5,
    path: "masters",
    isActive: true,
  },
];

export const CATEGORY_LIST = [
  {
    label: "All",
    value: "All",
    id: "all-categories",
    order: 0,
    path: "all",
    isActive: true,
  },
  {
    label: "Art, Design & Fashion",
    value: "ART_DESIGN_FASHION",
    id: "art-design-fashion",
    order: 0,
    path: "art",
    isActive: false,
  },
  {
    label: "Beauty, Cosmetology & Massage",
    value: "BEAUTY_COSMETOLOGY_MASSAGE",
    id: "beauty-cosmetology-massage",
    order: 0,
    path: "beauty",
    isActive: false,
  },
  {
    label: "Business",
    value: "BUSINESS_MANAGEMENT",
    id: "business-management",
    order: 0,
    path: "business",
    isActive: true,
  },
  {
    label: "Communication & Multimedia",
    value: "COMMUNICATION_MULTIMEDIA",
    id: "communication-multimedia",
    order: 0,
    path: "communication",
    isActive: false,
  },
  {
    label: "Computers & IT",
    value: "COMPUTERS_INFORMATION_TECHNOLOGY",
    id: "computers-information-technology",
    order: 0,
    path: "technology",
    isActive: true,
  },
  {
    label: "Criminal Justice",
    value: "CRIMINAL_JUSTICE_LEGAL",
    id: "criminal-justice-legal",
    order: 0,
    path: "criminal-justice",
    isActive: true,
  },
  {
    label: "Culinary Arts & Hospitality",
    value: "CULINARY_ARTS_HOSPITAILITY",
    id: "culinary-arts-hospitality",
    order: 0,
    path: "culinary",
    isActive: false,
  },
  {
    label: "Education",
    value: "EDUCATION_TEACHING",
    id: "education-teaching",
    order: 0,
    path: "education",
    isActive: true,
  },
  {
    label: "General Studies",
    value: "GENERAL_STUDIES",
    id: "general-studies",
    order: 0,
    path: "general",
    isActive: false,
  },
  {
    label: "Healthcare",
    value: "HEALTHCARE_MEDICINE",
    id: "healthcare-medicine",
    order: 0,
    path: "healthcare",
    isActive: true,
  },
  {
    label: "Liberal Arts",
    value: "LIBERAL_ARTS_HUMANITIES",
    id: "liberal-arts-humanities",
    order: 0,
    path: "liberal-arts",
    isActive: true,
  },
  {
    label: "Math, Science & Engineering",
    value: "MATH_SCIENCE_ENGINEERING",
    id: "math-science-engineering",
    order: 0,
    path: "math",
    isActive: false,
  },
  {
    label: "Nursing",
    value: "NURSING",
    id: "nursing",
    order: 0,
    path: "nursing",
    isActive: true,
  },
  {
    label: "Psychology",
    value: "PSYCHOLOGY",
    id: "psychology-counseling-social-work",
    order: 0,
    path: "psychology",
    isActive: true,
  },
  {
    label: "Religious Studies",
    value: "RELIGIOUS_STUDIES",
    id: "religious-studies",
    order: 0,
    path: "religious",
    isActive: true,
  },
  {
    label: "Skilled Trades & Vocational",
    value: "SKILLED_TRADES",
    id: "skilled-trades-vocational",
    order: 0,
    path: "skilled",
    isActive: false,
  },
];

export const CATEGORY_DEGREE_LIST = {
  All: ["all", "certificate_diploma", "associate", "bachelor", "master", "doctorate_specialist", "graduate_certificate"],
  ART_DESIGN_FASHION:  ["all", "certificate_diploma", "associate", "bachelor", "master", "doctorate_specialist", "graduate_certificate"],
  BEAUTY_COSMETOLOGY_MASSAGE: ["all", "certificate_diploma", "associate", "bachelor", "master", "doctorate_specialist", "graduate_certificate"],
  BUSINESS_MANAGEMENT: ["all", "certificate_diploma", "associate", "bachelor", "master", "doctorate_specialist"],
  COMMUNICATION_MULTIMEDIA: ["all", "certificate_diploma", "associate", "bachelor", "master", "doctorate_specialist", "graduate_certificate"],
  COMPUTERS_INFORMATION_TECHNOLOGY:  ["all", "certificate_diploma", "associate", "bachelor", "master"],
  CRIMINAL_JUSTICE_LEGAL:["all", "certificate_diploma", "associate", "bachelor", "master"],
  CULINARY_ARTS_HOSPITAILITY:["all", "certificate_diploma", "associate", "bachelor", "master", "doctorate_specialist", "graduate_certificate"],
  EDUCATION_TEACHING: ["all", "certificate_diploma", "associate", "bachelor", "master"],
  GENERAL_STUDIES: ["all", "certificate_diploma", "associate", "bachelor", "master", "doctorate_specialist", "graduate_certificate"],
  HEALTHCARE_MEDICINE: ["all", "certificate_diploma", "associate", "bachelor", "master"],
  LIBERAL_ARTS_HUMANITIES: ["all", "associate", "bachelor", "master"],
  MATH_SCIENCE_ENGINEERING: ["all", "certificate_diploma", "associate", "bachelor", "master", "doctorate_specialist", "graduate_certificate"],
  NURSING:  ["all", "associate", "bachelor", "certificate_diploma", "master"],
  PSYCHOLOGY: ["all", "associate", "bachelor", "certificate_diploma", "doctorate_specialist", "master"],
  RELIGIOUS_STUDIES: ["all", "bachelor", "doctorate_specialist", "master"],
  SKILLED_TRADES:  ["all", "certificate_diploma", "associate", "bachelor", "master", "doctorate_specialist", "graduate_certificate"],
}



export const topSectionHeadline = {
  "snhu":"Our Top Choice For Online Degrees",
  "regent-university":"Christian Leadership to Change the World",
  "south-university":"Online Education Opportunities for Distance Learners",
  "university-of-arizona-global-campus":"Flexible Online College Degrees to Fit Your Life",
  "post-university":"Education that supports the career you want",
  "post-university1":"Education that supports the career you want",
  "liberty-university":"Earn An Online Degree From The Comfort Of Your Home"
}


export const SNHUData = {
  college_id: "southern-new-hampshire-university",
  college_name: "Southern New Hampshire University",
  is_active: true,
  college_description:
      "Committed to providing accessible higher education for all\r\n200 career-focused programs with no set class times so you can learn online, on your schedule.\r\nDiverse student body with more than 3,000 on campus students & over 170,000 online students\r\nFlexible transfer policy, letting you transfer up to 90 credits towards a bachelor’s degree",
  logo_url: "https://collegenroll-static.s3.us-west-1.amazonaws.com/public_media/snhu.png",
  offer_level: null,
  provider_id: "snhu-linkout",
  location: {
      city: "",
      state: "",
      zip_code: "",
      distance: "",
  },
  degrees: ["Bachelor", "Master", "Doctorate/Specialist"],
  headline: "Committed to providing accessible higher education for all",
  click_url:
      "https://snhu.collegenroll.com/search/1/?q=snhuOmc2",
  start_date: "Program start date 13th May 2024",
  campus_name: "Online Program",
  campus_type: "Online",
  popular_program: "<h4>Popular Programs</h4><ul><li>Business & Management</li><li>Psychology & Counselling</li></ul>",
  university_redirect_url: "https://snhu.collegenroll.com/search/1/?q=snhuOmc2",
  program_flow_description:
      "<li>200 career-focused programs with no set class times so you can learn online, on your schedule.</li><li>Diverse student body with more than 3,000 on campus students & over 170,000 online students</li><li>Flexible transfer policy, letting you transfer up to 90 credits towards a bachelor’s degree*</li>",
  programs: [],
  ce_offer_id: "542276be-40c1-47c2-a832-8dedfe904a08",
  program_name: "All Programs",
  category: "all-categories",
};